import React, { useState, useEffect } from "react";
import "./internshipcontrols.css";
import Loading1 from '../../loading_animation/loading';

const InternshipTable = () => {
  const [interns, setInterns] = useState([]);
  const [domains, setDomains] = useState([]);
  const [slots, setSlots] = useState([]);
  const [config, setConfig] = useState(null);
  const [selected, setSelected] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error("Error loading config:", err));
  }, []);

  useEffect(() => {
    if (!config) return;
    fetch(`${config.BASE_URL}${config.FETCH_CONFIRMED_INTERNSHIPS}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ requestType: "fetchInterns" }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          const internsWithFields = data.interns.map((intern) => ({
            ...intern,
            intern_id: intern.application_id,
            domain: intern.domain || "",
            slot: "",
            internship_start_date: ""
          }));
          setInterns(internsWithFields);
          setDomains(data.domains);
          setSlots(data.slots);
        } else {
          console.error("Error from backend:", data.message);
        }
      })
      .catch((err) => console.error("Error fetching data:", err));
  }, [config]);

  // Handle checkbox toggle
  const toggleSelect = (internId) => {
    setSelected((prev) =>
      prev.includes(internId)
        ? prev.filter((id) => id !== internId)
        : [...prev, internId]
    );
  };

  // Update selected domain/slot in state
  const handleChange = (internId, field, value) => {
    setInterns((prev) =>
      prev.map((intern) =>
        intern.intern_id === internId ? { ...intern, [field]: value } : intern
      )
    );
  };

  // Confirm selected interns
  const handleConfirm = () => {
    if (selected.length === 0) {
      alert("Please select at least one intern to confirm.");
      return;
    }

    
    const confirmData = interns
      .filter((intern) => selected.includes(intern.intern_id))
      .map((intern) => ({
        application_id: intern.intern_id,
        domain: intern.domain,
        duration: intern.duration,
        slot: intern.slot,
        internship_start_date: intern.internship_start_date
      }));

    setIsLoading(true);
    fetch(`${config.BASE_URL}${config.CONFIRM_INTERNSHIPS}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ interns: confirmData }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          alert("Selected interns confirmed successfully!");
          setSelected([]);
        } else {
          alert("Error: " + data.message);
        }
      })
      .catch((err) => console.error("Error confirming interns:", err))
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="internship-table-container">
      <h2>Internship Applications</h2>
      <button
        className="confirm-button"
        style={{ marginBottom: "40px" }}
        onClick={handleConfirm}
      >
        Confirm Selected
      </button>

      <table className="internship-table">
        <thead>
          <tr>
            <th>Select</th>
            <th>Intern ID</th>
            <th>Name</th>
            <th>Transaction ID</th>
            <th>Payment Mode</th>
            <th>Domain</th>
            <th>Duration</th>
            <th>Selected Mode</th>
            <th>Applied at</th>
            <th>Payment Date</th>
            <th>Slot</th>
             <th>Internship Start Date</th> 
          </tr>
        </thead>
        <tbody>
          {interns.map((intern) => (
            <tr key={intern.intern_id}>
              <td>
                <input
                  type="checkbox"
                  checked={selected.includes(intern.intern_id)}
                  onChange={() => toggleSelect(intern.intern_id)}
                />
              </td>
              <td>{intern.intern_id}</td>
              <td>{intern.name}</td>
              <td>{intern.transaction_id || "-"}</td>
              <td>{intern.payment_mode || "-"}</td>
              <td>
                <select
                  value={intern.domain}
                  onChange={(e) =>
                    handleChange(intern.intern_id, "domain", e.target.value)
                  }
                >
                  <option value="">Select Domain</option>
                  {domains.map((d, i) => (
                    <option key={i} value={d.internship_domain_name}>
                      {d.internship_domain_name}
                    </option>
                  ))}
                </select>
              </td>
              <td>
  <select
    value={intern.duration || ""}
    onChange={(e) =>
      handleChange(intern.intern_id, "duration", e.target.value)
    }
  >
    <option value={intern.duration}>{intern.duration}</option> 
    {["one month", "two months", "four months", "six months"]
      .filter(opt => opt !== intern.duration)
      .map((opt, i) => (
        <option key={i} value={opt}>
          {opt}
        </option>
      ))}
  </select>
</td>

 <td>{intern.mode || "-"}</td>

  {/* Applied at */}
  <td>
    {intern.submitted_at
      ? new Date(intern.submitted_at).toLocaleDateString()
      : "-"}
  </td>
  
              <td>{new Date(intern.added_at).toLocaleDateString()}</td>
              <td>
                <select
                  value={intern.slot}
                  onChange={(e) =>
                    handleChange(intern.intern_id, "slot", e.target.value)
                  }
                >
                  <option value="">Select Slot</option>
                  {slots.map((s, i) => (
                    <option key={i} value={s.slot_no + "@" + s.batch}>
                      {s.slot_no} ({s.timings}) - {s.batch}
                    </option>
                  ))}
                </select>
              </td>

               <td>
                <input
                  type="date"
                  value={intern.internship_start_date}
                  onChange={(e) =>
                    handleChange(
                      intern.intern_id,
                      "internship_start_date",
                      e.target.value
                    )
                  }
                />
              </td>
              
            </tr>
          ))}
        </tbody>
      </table>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
          }}
        >
          <Loading1 />
        </div>
      )}
    </div>
  );
};

export default InternshipTable;
